const CRC8_INITIAL_VALUE = 0x79
const CRC8_POLYNOMIAL = 0x8c

export function crc8(
  bytes: number[],
  initialValue: number = CRC8_INITIAL_VALUE
): number {
  let crc = initialValue
  for (const byte of bytes) {
    crc ^= byte & 0xff
    for (let i = 0; i < 8; i++) {
      if ((crc & 1) === 1) {
        crc = (crc >> 1) ^ CRC8_POLYNOMIAL
      } else {
        crc >>= 1
      }
    }
  }
  return crc & 0xff
}
